<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>

                    <div class="content">
                        <div class="videoLearningCont" v-if='!isPhone && isChrome == "Chrome" ' v-loading='loading'>

                            <div class="videoLearningLeft fl">
                                <div class="videoLearningTitle">
                                  <div class="videoLearningTitle-l">{{detail.name}}</div>
                                  <div class="videoLearningTitle-r">（请勿使用倍速播放行为，学习数据将自动标记为不合格，请以1.0倍速正常观看）</div>
                                </div>
                                <div class="videoBox">
                                    <!-- <video width="90%" controls>
                                        <source width="100%" height="374"
                                            :src="detail.video_url" type="video/mp4">
                                    </video> -->

                                    <div class="prism-player" id="aliplayer"></div>

                                    <div class="teacherIntroduce">
                                        <p class="teacherIntroduceTitle">讲师介绍</p>
                                        <p>
                                            <img :src="detail.teacher_info.avatar" class="teacherInfoAvatar"
                                                v-if='detail.teacher_info' alt="">
                                            <div class="detailTeacherIntroduce" v-if='detail.teacher_info'
                                                v-html='detail.teacher_info.description'></div>
                                        </p>
                                        <!-- <p class="detailTeacherIntroduce" v-if='detail.teacher_info'
                                            v-html='detail.teacher_info.description'></p> -->

                                    </div>

                                </div>
                            </div>

                            <div class="videoLearningRight fl">
                                <div class="courseIntroduce">
                                    <p class="teacherIntroduceTitle">课程介绍</p>
                                    <p class="detailTeacherIntroduce" v-if='detail.course_description'
                                        v-html='detail.course_description'>
                                        <!-- {{detail.course_description}} -->
                                    </p>

                                </div>

                            </div>

                        </div>

                        <div class="platform" v-if='isPhone'>
                            请下载APP或使用PC观看
                        </div>

                        <div class="platform" v-if='isChrome != "Chrome"'>
                            请下载谷歌浏览器观看
                        </div>


                    </div>

                    <el-dialog title='' class="cameraBox" :visible.sync="showFace" :close-on-click-modal='false'
                        :close-on-press-escape='false' :show-close='false'>
                        <camera :uploadLoading='uploadLoading' @fileUpload="fileUpload" :show='showFace'></camera>
                    </el-dialog>

                    <el-dialog title='' center class="hideTitle" :visible.sync="showVideoOver" width="30%"
                        :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false'>
                        <div class="pop">
                            <div class="dialogCont">
                                <p class="popTitle">学习辛苦了</p>
                                <p class="popCont">您已完成{{ detail.name }}</p>
                                <div class="confirmPopBtn" @click="videoOverSure">确认</div>
                            </div>
                        </div>
                    </el-dialog>

                    <!-- 课程评价弹窗 -->
                    <el-dialog
                        title="评价"
                        :close-on-click-modal='false'
                        :close-on-press-escape='false'
                        :visible.sync="dialogVisible"
                        width="620px"
                        class="evaluation-wrap"
                        >
                        <div class="evaluation">
                            <el-radio-group v-model="evaluation">
                                <div class="radio">
                                    <el-radio border label="1">不太满意</el-radio>
                                    <el-radio border label="2">一般满意</el-radio>
                                </div>
                                <div class="radio">
                                    <el-radio border label="3">基本满意</el-radio>
                                    <el-radio border label="4">非常满意</el-radio>
                                </div>
                            </el-radio-group>
                            <el-input
                                type="textarea"
                                :rows="6"
                                placeholder="请输入对本次课程的评价…"
                                v-model="textarea">
                            </el-input>
                        </div>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="dialogEvaluate">提交</el-button>
                        </span>
                    </el-dialog>

                    <!--所有课程学完之后提示弹窗  -->
                    <el-dialog
                        title="温馨提示"
                        :close-on-click-modal='false'
                        :close-on-press-escape='false'
                        :visible.sync="lastDiaVisible"
                        width="620px"
                        class="evaluation-wrap"
                        >
                        <div class="evaluation">
                           <span>您的学习档案已实时上传，请耐心等待审核（最长7个工作日）。如学习档案审核通过，即可尝试登陆“湖南省药师考核”微信小程序参加考核。</span>
                        </div>
                        <span slot="footer" class="dialog-footer">
                            <el-button type="primary" @click="dialogSure">确认</el-button>
                        </span>
                    </el-dialog>


                </section>
            </el-main>
        </el-container>
    </el-container>

</template>


<script>

import commonheader from '../common/commonHeader.vue'
import leftMenu from "../common/leftMenu.vue";
import exit from "../common/exit.vue";
import camera from "./faceCollection/Camera.vue"
export default {
    name: "index",
    components: {
        commonheader,
        leftMenu,
        exit,
        camera
    },
    data () {
        return {
            is_last: '',
            dialogVisible: false,
            lastDiaVisible: false,
            evaluation: '',
            textarea: '',
            loading: true,
            detail: {},
            timer: null,
            limitedTimer: null,
            scriptTagStatus: 0,
            isReload: false,
            instance: null,

            routeParams: {},

            showFace: false,

            player: null,

            showVideoOver: false,
            showVideoAllOver: false,
            videoName: '',

            isPhone: false,
            uploadLoading: false,
            record_id: '',
            state: 0,

            recordFlg: false,

            isChrome:false,
            // safariFlg:true,
            pauseFlg:false, //是否暂停
            photo:[],// 抓拍时间节点
            photoNum:0, //抓拍游标

            startDuration:null,
            completeDuration:null,

        };
    },
    mounted: function () {

        document.getElementsByTagName("html")[0].className = "my-page";

        this.routeParams = this.$route.query;

        // this.isChrome =  navigator.userAgent.indexOf('Chrome') > -1  // 是否是谷歌
        var info = new Browser();
        this.isChrome = info.browser;
        console.log(info.browser)

        if (this._isMobile()) {
            this.isPhone = true;
        }else if( this.isChrome != 'Chrome' ){
            this.loading = false;
        }else if( this.isChrome == 'Chrome' ) {

            if (this.routeParams.tryIt || this.routeParams.classState == 2) {
                this.getDetail();
            } else {
                if (localStorage.getItem('videoRefresh')) {
                    localStorage.removeItem('videoRefresh');
                    this.getDetail();
                } else {
                    this.$router.push('/myCourse')
                }
            }
        }
        this.dialogLast();//调用是否为最后一节课

    },
    /**
      * 清除定时器
      */
    beforeDestroy () {
        clearInterval(this.timer);
        this.timer=null
        window.clearTimeout(this.limitedTimer)
        this.limitedTimer=null

    },
    methods: {
        /**
         * 学习辛苦了 弹窗
         */
        videoOverSure () {
            this.showVideoOver = false;
            this.$router.push('/myCourse')
        },
        /**
         * 判断是否是手机
         */
        _isMobile () {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },

        /**
         * 获取视频
         */
        getDetail () {
            let _this = this;
            let params = {
                cid: this.routeParams.cid,
                formal: this.routeParams.tryIt
            }
            this.$store.dispatch('webcourse_detail', params).then((res) => {
                _this.detail = res.data;
                _this.loading = false;
                _this.videoStart(res.data);
                if(res.data.is_grade == 0 && res.data.progress.progress == 100) {
                    _this.dialogVisible = true;
                }
                if(res.data.photo){
                 _this.photo=res.data.photo
                }
            }).catch(error => {
                this.loading = false;
                console.log('错误信息：', error)
            })
        },
        /**
         * 是否是最后一节课
         */
        dialogLast () {
            let _this = this;
                let params = {
                    year: this.routeParams.year,
                    course_id: this.routeParams.cid
                }
                this.$store.dispatch('course_last', params).then((res) => {
                    _this.is_last =  res.data.is_last;
                }).catch(error => {
                    this.loading = false;
                    console.log('错误信息：', error)
                })

        },
        /**
         * 评价弹窗
         */
        dialogEvaluate () {
            let _this = this;
            if(this.evaluation !== '') {
                let params = {
                    course_id: this.routeParams.cid,
                    stu_grade: this.evaluation,
                    stu_commont: this.textarea,
                    type: 0 //type 课程类型：0专业课，1公需课
                }
                this.$store.dispatch('course_evaluate', params).then((res) => {
                    _this.dialogVisible = false;
                    if(_this.is_last == 0) {
                        setTimeout(() => {
                            _this.$router.push('/myCourse')
                        }, 1000)
                    } else {
                        setTimeout(() => {
                            _this.lastDiaVisible = true;
                        }, 1000)
                    }
                }).catch(error => {
                    this.loading = false;
                    console.log('错误信息：', error)
                })
            } else{
                this.$message('请评价该课程的满意度');
            }
        },
        /**
         * 点击最后一节课提示弹窗
         */
        dialogSure () {
            this.lastDiaVisible = false;
            setTimeout(() => {
                this.$router.push('/myCourse')
            }, 1000)
        },
        /**
         * 视频初始化
         */
        videoStart (data) {
            let _this = this;
            this.player = new Aliplayer({
                id: 'aliplayer',
                width: '100%',
                autoplay: true,
                // skinLayout:false,
                //支持播放地址播放,此播放优先级最高
                source: data.video_url,
                //播放方式二：点播用户推荐
                vid: '',
                playauth: '',
                cover: data.thumb,
                controlBarVisibility: 'always',
            }, function (player) {



                //继续学习跳转指定播放位置
                if (_this.routeParams.classState == 1) {
                    // console.log(_this.detail.progress.learn_time)
                    //容错
                    if (_this.detail.progress) {

                        player.seek(parseInt(_this.detail.progress.learn_time));
                    }
                }

                //开始播放
                player.on('play', function () {
                    // player.seek(100);
                    console.log('开始播放')

                    // if( !this.timer ){

                    //不是试看
                    if (!_this.routeParams.tryIt) {
                        //不是开始复习
                        if (_this.routeParams.classState != 2) {

                            // if( /Apple/.test(navigator.vendor) ){

                            // }
                            if (_this.recordFlg) {
                                clearInterval(_this.timer)
                                _this.timer = setInterval(() => {
                                    if (player._duration) {
                                        _this.setRecode(player);
                                    }
                                }, 10000);
                            }
                            _this.recordFlg = true;

                        }
                    }
                    // }
                });
                //暂停播放
                player.on('pause', function () {
                  console.log('暂停监听')
                  if(!_this.showFace){
                    _this.record_id = ''; //初始化 record_id
                  }
                  _this.pauseFlg = true
                   clearInterval(_this.timer)

                });
                //播放结束
                player.on('ended', function () {

                    clearInterval(_this.timer);
                    if (!_this.routeParams.tryIt) {
                        if (_this.routeParams.classState != 2) {
                            _this.state = 1;
                            _this.setRecode(player, 1);
                        }
                    }
                    // 判断是否评价过了
                    if(_this.detail.is_grade == 0) {
                        _this.dialogVisible = true;
                    }else {
                        _this.$router.push('/myCourse');
                    }

                    // if (_this.routeParams && _this.routeParams.classState != 2) {
                    //     // _this.showVideoOver = true;
                    // }
                });
             console.log('player',player)


                // 禁止拖拽 开始拖动
                player.on('startSeek', function (e) {
                  console.log('startSeek',e)
                  /*
                  // 当用户尝试拖动进度条时触发
                  if(!_this.startDuration){
                     _this.startDuration=player.getCurrentTime()
                  }
                  */

                    if (_this.routeParams.classState == 0 || _this.routeParams.classState == 1) {
                       _this.$router11.back(-1)
                    }


                })

                //结束拖动
                player.on('completeSeek', function (e) {
                  //e.paramData
                  _this.completeDuration=player.getCurrentTime()

                  console.log(_this.startDuration,_this.completeDuration)
                  console.log('completeSeek')
                  /*
                  if (_this.routeParams.classState == 0 || _this.routeParams.classState == 1) {
                     console.log(11111)
                      if(_this.completeDuration>_this.startDuration){
                        player.seek(Number(_this.startDuration));
                      }else{

                        player.seek(Number(_this.completeDuration));
                      }
                  }
                  _this.startDuration=null
                  player.play()
                  */
                    // console.log(player.getCurrentTime()+'-结束-')
                    // if (Number(player.getCurrentTime())>Number(longtime)) {
                    // //
                    //  player.disableSeek();
                    //    player.seek(Number(nowtime));
                    // }
                })


                let totalTime = player._duration;
                let isOverUpdate = true;
                let tryflg = true;

                let startflg = true;
                let num = [];//抓拍两个时间
                //更新
                player.on('timeupdate', function (e) {
                  console.log(e)

                    //如果是试看
                    if (_this.routeParams.tryIt == 1) {
                        //大于360秒退出 6分钟
                        if (player.getCurrentTime() >= 360) {
                            if (tryflg) {
                                tryflg = false;
                                player.pause();
                                _this.$message('试看已结束');
                                setTimeout(() => {
                                    _this.$router.push('/signStudy')
                                }, 2000)
                            }

                        }
                    }

                    //复习不做操作
                    if (_this.routeParams.classState == 2) {
                        return false;
                    }

                    if (startflg) {
                        startflg = false;


                        //继续学习跳转指定播放位置
                        //苹果safari 需要开始播放才能seek 做个兼容  /Apple/.test(navigator.vendor)
                        if (_this.routeParams.classState == 1 && /Apple/.test(navigator.vendor) ) {
                            //容错
                            if (_this.detail.progress) {
                                player.seek(parseInt(_this.detail.progress.learn_time));
                            }
                        }


                        //不是试看
                        if (!_this.routeParams.tryIt) {
                            //不是开始复习
                            if (_this.routeParams.classState != 2) {
                                //延迟执行确保player能够获取到总时长
                                setTimeout(() => {
                                    //两次拍照时间记录
                                    num = _this.photograph(player);
                                    _this.setRecode(player);
                                    clearInterval(_this.timer)
                                    _this.timer = setInterval(() => {
                                        _this.setRecode(player);
                                    }, 10000);

                                }, 1000)
                            }
                        }


                    }

                    var total_duration=player._duration
                    // console.log(parseInt(total_duration*(_this.photo[_this.photoNum]/100)))
                    //console.log('photoNum',_this.photoNum)
                    if(!_this.startDuration && _this.photo.length>0 && parseInt(player.getCurrentTime()) >= parseInt(total_duration*(_this.photo[_this.photoNum]/100))){
                      //console.log(_this.photo,_this.photo[_this.photoNum],parseInt(total_duration*(_this.photo[_this.photoNum]/100)))
                       player.pause();

                       _this.showFace = true; //显示人脸识别
                       //限时上传人脸识别
                       _this.limitedTimer=window.setTimeout(function(){

                          console.log('超时跳转',_this.limitedTimer)
                          if(_this.limitedTimer){
                            window.location.reload()
                          }

                       },60000)
                        clearInterval(_this.timer);
                       this.timer = null;
                       if (document.getElementsByClassName('fullscreen').length) {
                           document.getElementsByClassName('prism-fullscreen-btn')[0].click()
                       }
                    }
                    //注释之前的人脸识别
                    /*
                    if (parseInt(player.getCurrentTime()) == num[0]) {
                        num.splice(0, 1)
                        //显示人脸拍照
                        _this.showFace = true;
                        _this.state = 1;//表示一小段结束
                        _this.setRecode(player);
                        player.pause();
                        clearInterval(_this.timer);
                        this.timer = null;

                        if (document.getElementsByClassName('fullscreen').length) {
                            document.getElementsByClassName('prism-fullscreen-btn')[0].click()
                        }
                    }
                    if (parseInt(player.getCurrentTime()) == num[1]) {
                        num.splice(1, 1)
                        _this.showFace = true;
                        _this.state = 1;//表示一小段结束
                        _this.setRecode(player);
                        player.pause();
                        clearInterval(_this.timer);
                        this.timer = null;
                        if (document.getElementsByClassName('fullscreen').length) {
                            document.getElementsByClassName('prism-fullscreen-btn')[0].click()
                        }
                    }
                    */
                    //30秒视频记录结束
                    if (player._duration - 30 <= player.getCurrentTime()) {
                        if (isOverUpdate) {
                            isOverUpdate = false;
                            clearInterval(_this.timer);
                            _this.setRecode(player, 1);
                            _this.timer = setInterval(() => {
                                _this.setRecode(player, 1);
                            }, 10000)
                        }
                    }
                })
                player.getDuration();
            })
        },

        /**
         * 记录进度
         */
        setRecode (player, isOver) {
            let _this = this;
            if(_this.pauseFlg && !_this.showFace){
               //_this.record_id = ''
            }
            let params = {
                cid: Number(this.routeParams.cid),
                start_time: parseInt(new Date().getTime() / 1000),
                vlength: Math.ceil(player._duration),
                pos: Math.ceil(player.getCurrentTime()),
                record_id: _this.record_id,
                state: _this.state
            };
            if (isOver) {
                params['pos'] = Math.ceil(player._duration);
                params['flag'] = isOver;
                params['state'] = 1;
            }

            console.log(params, '111111111111')
            this.$store.dispatch('records', params).then((res) => {
              console.log('pauseFlg',_this.pauseFlg)

                  _this.record_id = res.data.record_id;

                  _this.pauseFlg=false


            })
        },

        /**
         * 两次拍照
         */
        photograph (player) {

            var oneRandom = parseInt(this.getRandom(10, 40)) / 100;
            var twoRandom = parseInt(this.getRandom(60, 90)) / 100;

            var onePhoto = parseInt(player._duration * oneRandom);
            var twoPhoto = parseInt(player._duration * twoRandom);

            // console.log('拍照时间:' + onePhoto, twoPhoto)
            return [onePhoto, twoPhoto];


        },
        /**
         * 获取随机数
         */
        getRandom (m, n) {
            return (Math.random() * (m - n) + n)
        },

        /**
         * 上传人脸
         */
        fileUpload (result) {
           let _this = this;
            this.uploadLoading = true;
            var photo=_this.photo
            var data={}
            data.avatar=result
            data.course_id=_this.routeParams.cid
            if(photo.length>0){
              data.percent=photo[_this.photoNum]
            }
           // console.log(data)
            // console.log({ avatar: result, course_id: this.routeParams.cid })
            this.$store.dispatch('avatar', data).then((res) => {
            console.log('人脸识别',res)
                if (res.code == 200) {
                    this.$message({
                        message: '上传成功',
                        type: 'success'
                    });

                    this.showFace = false;
                    console.log(this.limitedTimer)
                    window.clearTimeout(this.limitedTimer)
                    console.log(this.limitedTimer,'limitedTimer')
                    this.limitedTimer=null
                    this.state = 0;
                   // this.record_id = '';
                    _this.photoNum++
                    this.player.play();

                } else {
                    this.$message.error(res.message);
                }
                this.uploadLoading = false;
            }).catch(() => {
                this.uploadLoading = false;
            })
        },

        /**
         * 上传人脸关闭
         * handleClose
         */
        handleClose () {
            this.showFace = false;
        }

    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='stylus'>
@media (min-width: 1399px)
    .el-container-master
        width 1400px
        margin auto
.el-aside
    background #fff
.el-main
    padding 0
    background #fff
.content
    padding 47px 57px 0 86px
    flex 1
    border-top 10px solid #f8f8f8
    border-left 10px solid #f8f8f8
.videoLearningCont
    overflow hidden
    padding-bottom 80px
.videoLearningLeft
    box-sizing border-box
    width 60%
    padding-right 50px
    border-right 1px dotted #667dab
.videoLearningRight
    box-sizing border-box
    width 40%
    padding-left 30px
.videoLearningTitle
    width: 100%
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
.videoLearningTitle-l
    width: 100%
    color #333
    font-size 18px
    text-align center
    line-height 30px
    overflow hidden
    text-overflow ellipsis
    display -webkit-box
    -webkit-line-clamp 2
    -webkit-box-orient vertical
.videoLearningTitle-r
    width: 100%
    font-size: 14px
    color: red
    margin-top: 6px
    text-align: center
    line-height: 20px
.videoBox
    margin-top 30px
.videoBox video
    margin 0 auto
    display block
    height 374px
.teacherIntroduce
    margin-top 50px
.teacherIntroduceTitle
    color #333
    font-size 16px
    font-weight bold
    padding-left 10px
    margin 20px 0
    background-image $menu_border
    background-repeat no-repeat
    background-size 4px 22px
    background-position 0 0
.detailTeacherIntroduce
    color #999
    font-size 14px
    line-height 26px
    margin-top 20px
    padding-left 10px
.courseIntroduce
    /* margin-top: 90px; */
.popTitle
    text-align center
    font-size 16px
    color #333
    letter-spacing 2px
    font-weight bold
    padding 20px 20px 0
.popCont
    font-size 16px
    color #333
    text-align center
    letter-spacing 2px
    padding 15px 0 15px
    border-bottom 1px solid #eee
.confirmPopBtn
    font-size 16px
    color #0173FF
    text-align center
    letter-spacing 2px
    cursor pointer
    height 48px
    text-align center
    line-height 48px
.onlyPopCont
    text-align center
    font-size 16px
    color #333
    letter-spacing 2px
    font-weight bold
    padding 45px 25px 25px
    border-bottom 1px solid #eee
.confirmPopBtn
    height 48px
    line-height 48px
.confirmPopBtn>p
    float left
    width 50%
    text-align center
    box-sizing border-box
.confirmPopBtn>p.sureBtn
    color #333
.confirmPopBtn>p.simulationExam
    color #0173FF
    border-left 1px solid #eee
.teacherInfoAvatar
    display inline
    float left
    padding 0 20px 20px 0
    max-width 200px
.platform
    text-align center
    color #333
</style>
<style lang="stylus">
.prism-setting-btn, .prism-cc-btn
    display none
.detailTeacherIntroduce img
    max-width 100%
.videoLearningRight img
    width 100% !important
.hideTitle
    .el-dialog__header
        display none
    .el-dialog__body
        padding 0
    .el-dialog
        border-radius 8px
.cameraBox
    .el-dialog
        width 432px !important
.evaluation
    width 500px
    margin 0 auto
    .radio
        margin-bottom 26px
    span
        font-size 16px
        color #1E1E1E
        line-height 22px
.evaluation-wrap
    .el-radio.is-bordered
        width 226px
        height 46px
        padding 12px 20px 0 10px
        text-align center
        border 1px solid #F2F2F2
        background #F2F2F2
        border-radius 23px
    .el-radio__label
        color #666666
.evaluation-wrap
    .el-dialog__body
        padding 30px 20px 20px 20px
    .el-radio.is-bordered.is-checked
        background linear-gradient(41deg, rgba(75, 183, 252, 0.07) 0%, rgba(1, 115, 255, 0.07) 100%)
.evaluation-wrap
    .el-dialog__header
        text-align center
        border-bottom 1px solid #DBDBDB
        .el-dialog__title
            font-size 22px
            font-weight bold
            color #1E1E1E
    .el-dialog__footer
        text-align center
        padding-bottom 30px
        .el-button
            font-size 16px
            width 290px
            height 42px
            background linear-gradient(41deg, #4BB7FC 0%, #0173FF 100%)
    .el-textarea
        margin-top 4px
        .el-textarea__inner
            background #F2F2F2
            font-size 16px
            line-height 24px
            border 1px solid #F2F2F2
            border-radius 4px
            padding-top 14px

</style>



// WEBPACK FOOTER //
// src/components/my/videoLearning.vue